import styled from 'styled-components';
import { color, duration, ease, font, radius, shadow } from '../../../theme/tokens';
import { reducedMotion } from '../../atome/motion/motion.styled';

export const StateSection = styled.section`
  padding: 4rem 0 5rem;
  background: ${color.cream};
`;

export const SkeletonGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(255px, 1fr));
  gap: 1.6rem;
`;

export const SkeletonCard = styled.div`
  border-radius: ${radius.lg};
  overflow: hidden;
  background: ${color.paper};
  box-shadow: ${shadow.soft};
  padding-bottom: 1.3rem;

  > div:first-child {
    height: 250px;
    border-radius: 0;
  }

  > div:not(:first-child) {
    margin: 0.9rem 1.3rem 0;
  }
`;

export const ErrorPanel = styled.div`
  max-width: 32rem;
  margin: 0 auto;
  padding: 3rem 2rem;
  text-align: center;
  border-radius: ${radius.lg};
  background: ${color.paper};
  box-shadow: ${shadow.soft};

  h3 {
    font-family: ${font.display};
    font-size: 1.9rem;
    color: ${color.ink};
    margin: 0 0 0.6rem;
  }

  p {
    font-family: ${font.body};
    color: ${color.inkSoft};
    line-height: 1.7;
    margin: 0 0 1.6rem;
  }
`;

export const RetryButton = styled.button`
  padding: 0.85rem 1.9rem;
  border: none;
  border-radius: ${radius.pill};
  cursor: pointer;
  font-family: ${font.body};
  font-size: 0.92rem;
  letter-spacing: 0.05em;
  color: #fff;
  background: ${color.forest};
  box-shadow: 0 12px 26px rgba(74, 112, 97, 0.24);
  transition:
    transform ${duration.base} ${ease.spring},
    background ${duration.base} ${ease.out};

  &:hover {
    background: ${color.forestDeep};
    transform: translateY(-3px);
  }

  ${reducedMotion};
`;
